import { useContext, useState } from 'react';
import * as R from 'ramda';

import AddFormsModal from '@atom/components/common/workOrderDetail/addFormsModal/AddFormsModal';
import TaskContext from '@atom/components/workOrderPreview/taskView/TaskContext';
import WorkOrderPreviewContext from '@atom/components/workOrderPreview/WorkOrderPreviewContext';
import { Icon, IconButton } from '@atom/mui';
import {
  AddIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  LibraryBooksIcon,
} from '@atom/mui/icons';
import api from '@atom/utilities/api';
import {
  doesNotHaveRolePermissions,
  ROLE_SETS,
} from '@atom/utilities/authUtilities';
import { WORK_ORDERS_ENDPOINT } from '@atom/utilities/endpoints';

import FormTile from './FormTile';

import classes from './formSection.module.css';

const styles = {
  icon: {
    paddingTop: '0.75rem',
  },
};

const FormSection = () => {
  const { workOrderDetail, refetch, loading } = useContext(
    WorkOrderPreviewContext,
  );
  const { task } = useContext(TaskContext);

  const [open, setOpen] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<boolean>(true);

  const handleAddForm = async (formTemplateIds: string[]) => {
    const endpoint = `${WORK_ORDERS_ENDPOINT}/${workOrderDetail.id}/tasks/${task.id}/formInstances`;

    await api.post(endpoint, { formTemplateIds });

    setOpen(false);
    refetch();
  };

  const isSectionEmpty = R.isEmpty(task.formInstanceIds);
  const totalCount = R.length(task.formInstanceIds);
  const icon = expanded ? ExpandLessIcon : ExpandMoreIcon;
  const isEditDisabled =
    workOrderDetail.isClosed || doesNotHaveRolePermissions(ROLE_SETS.INSPECTOR);

  return (
    <>
      <div className={classes.sectionContainer}>
        <Icon style={styles.icon} icon={LibraryBooksIcon} />
        <div className={classes.rightContainer}>
          <div className={classes.headerContainer}>
            <div className={classes.left}>
              <div className={classes.sectionTitle}>Forms</div>
              <div className={classes.totalCount}>{totalCount}</div>
            </div>
            <div className={classes.right}>
              {expanded && (
                <IconButton
                  onClick={() => setOpen(!isEditDisabled)}
                  edge="end"
                  tooltip="Add Forms"
                >
                  <Icon icon={AddIcon} />
                </IconButton>
              )}
              <IconButton onClick={() => setExpanded(!expanded)} edge="end">
                <Icon icon={icon} />
              </IconButton>
            </div>
          </div>
          {expanded && (
            <div>
              {isSectionEmpty ? (
                <div className={classes.emptySectionText}>Add Forms</div>
              ) : (
                <>
                  {task.formInstanceIds.map(formInstanceId => (
                    <FormTile
                      key={formInstanceId}
                      formInstanceId={formInstanceId}
                    />
                  ))}
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <AddFormsModal
        schemaId={workOrderDetail?.inventoryAssetSchemaId}
        loading={loading}
        open={open}
        onClose={() => setOpen(false)}
        handleAddForm={handleAddForm}
      />
    </>
  );
};

export default FormSection;
